import { render, staticRenderFns } from "./FeedbackScreen.vue?vue&type=template&id=660b86d7&scoped=true&"
import script from "./FeedbackScreen.vue?vue&type=script&lang=js&"
export * from "./FeedbackScreen.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackScreen.vue?vue&type=style&index=0&id=660b86d7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660b86d7",
  null
  
)

export default component.exports